var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 16.25C10.0637 16.25 12.75 14.9069 12.75 13.25C12.75 11.5931 10.0637 10.25 6.75 10.25C3.43629 10.25 0.75 11.5931 0.75 13.25C0.75 14.9069 3.43629 16.25 6.75 16.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 13.25V20.25C0.75 21.91 3.44 23.25 6.75 23.25C10.06 23.25 12.75 21.91 12.75 20.25V13.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 16.75C12.75 18.41 10.06 19.75 6.75 19.75C3.44 19.75 0.75 18.41 0.75 16.75"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 15.75H21.75C22.1478 15.75 22.5294 15.592 22.8107 15.3107C23.092 15.0294 23.25 14.6478 23.25 14.25V2.25C23.25 1.85218 23.092 1.47064 22.8107 1.18934C22.5294 0.908035 22.1478 0.75 21.75 0.75H2.25C1.85218 0.75 1.47064 0.908035 1.18934 1.18934C0.908035 1.47064 0.75 1.85218 0.75 2.25V8.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.31995 6.90999C9.49422 6.54155 9.74175 6.21248 10.0474 5.94287C10.3531 5.67326 10.7105 5.46876 11.0978 5.34186C11.4851 5.21496 11.8943 5.16832 12.3002 5.20478C12.7062 5.24123 13.1004 5.36003 13.4589 5.55391C13.8175 5.7478 14.1327 6.0127 14.3854 6.33246C14.6382 6.65222 14.8231 7.02013 14.929 7.41373C15.0348 7.80733 15.0593 8.21837 15.001 8.62177C14.9427 9.02516 14.8029 9.41245 14.5899 9.75999"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M4.50488 4.88C4.29778 4.88 4.12988 4.71211 4.12988 4.505C4.12988 4.2979 4.29778 4.13 4.50488 4.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M4.50488 4.88C4.71199 4.88 4.87988 4.71211 4.87988 4.505C4.87988 4.2979 4.71199 4.13 4.50488 4.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M19.4951 12.3701C19.288 12.3701 19.1201 12.2023 19.1201 11.9951C19.1201 11.788 19.288 11.6201 19.4951 11.6201"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M19.4951 12.3701C19.7022 12.3701 19.8701 12.2023 19.8701 11.9951C19.8701 11.788 19.7022 11.6201 19.4951 11.6201"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPay);
export default __webpack_public_path__ + "static/media/account-pay.a3912c71441c14fa4860031ea34ae3b5.svg";
export { ForwardRef as ReactComponent };